export default __webpack_public_path__ + "static/media/checkbox_enabled_mobile.bd3b3ee2.svg";